'use strict';

var translations = {
    warnings: {
        straightRow: 'Hindari deretan tombol yang sebaris, seperti "asdf".',
        simpleRepeat: 'Hindari perulangan kata dan karakter, seperti "aaa" dan "abcabc".',
        extendedRepeat: 'Hindari perulangan kata dan karakter, seperti "aaa" dan "abcabc".',
        sequences: 'Hindari urutan seperti "abc" atau "6543".',
        recentYears: 'Hindari tahun-tahun terbaru, seperti "2020".',
        dates: 'Hindari tanggal.',
        topTen: 'Hindari kata sandi umum.',
        topHundred: 'Hindari kata sandi umum.',
        common: 'Hindari kata sandi umum.',
        similarToCommon: 'Hindari kata sandi umum.',
        wordByItself: 'Hindari penggunaan satu kata saja.',
        namesByThemselves: 'Hindari penggunaan nama dan nama belakang saja.',
        commonNames: 'Hindari penggunaan nama dan nama belakang saja.',
        userInputs: '',
        pwned: '',
        keyPattern: '',
    },
    suggestions: {
        useWords: 'Gunakan string panjang dengan lebih dari dua kata; hindari frasa umum.',
        anotherWord: 'Tambahkan satu atau dua kata lagi. Kata-kata yang tidak umum lebih baik.',
        repeated: 'Hindari perulangan kata dan karakter, seperti "aaa" dan "abcabc".',
        l33t: 'Hindari penggantian yang mudah ditebak, seperti "@" menggantikan "a" (misalnya "@pple" alih-alih "Apple").',
        reverseWords: 'Hindari kata-kata yang dibalik, seperti "elppa" (kebalikan dari "apple").',
        allUppercase: 'Semua huruf kapital hampir sama mudahnya ditebak seperti semua huruf kecil.',
        dates: 'Hindari tanggal.',
        associatedYears: 'Hindari tanggal.',
        recentYears: 'Hindari tahun-tahun terbaru, seperti "2020".',
        sequences: 'Hindari urutan seperti "abc" atau "6543".',
        pwned: '',
        capitalization: '',
        longerKeyboardPattern: '',
        noNeed: '',
    },
    timeEstimation: {
        ltSecond: 'less than a second',
        second: '{base} second',
        seconds: '{base} seconds',
        minute: '{base} minute',
        minutes: '{base} minutes',
        hour: '{base} hour',
        hours: '{base} hours',
        day: '{base} day',
        days: '{base} days',
        month: '{base} month',
        months: '{base} months',
        year: '{base} year',
        years: '{base} years',
        centuries: 'centuries',
    },
};

export default translations;
//# sourceMappingURL=translations.js.map
